// extracted by mini-css-extract-plugin
module.exports = {"gallery":"GalleryView_gallery__SYsap","galleryCard":"GalleryView_galleryCard__1qvq6"};